import React from 'react';
import { Tree, TreeSelect } from 'antd';
import { DownOutlined, BookOutlined } from '@ant-design/icons';
import _ from 'lodash'
const { DirectoryTree } = Tree

class TreeComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      treeData: []
    }
  }

  onCheck = (checkedKeys, info) => {
    this.props.onCheck(checkedKeys, info)
  };

  componentDidMount () {
  }

  location (url) {
    window.open(url);
  }

  title (t) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div>{t.title}</div>
          <div style={{ fontSize: 13.333 }}>{t.url}</div>
        </div>
        <div>
          <a className="line" onClick={() => this.location(t.url)}>跳转</a>
        </div>
      </div>
    )
  }

  fun (list) {
    const bookData = [ ...this.props.data ]
    const newList = []

    for (let i = 0; i < list.length; i++) {
      const item = list[i]
      const children = []
      if (item.child) children.push( ...this.fun(item.child))
      const ft = bookData.filter(n => {
        return n.category_id === item.id
      }).map(n => {
        n.key = n.id
        n.icon = n.icon ? <img src={n.icon} /> : <BookOutlined />
        n.text_title = n.title
        n.title = this.title(n)
        return n
      })
      children.push(...ft)
      newList.push({
        title: item.title,
        text_title: item.title,
        key: item.id,
        children,
        type: 'category'
      })
    }
    return newList
  }

  get treeDom () {
    const treeData = this.props.tree
    const bookData = [ ...this.props.data ]

    const rt = this.fun(treeData)

    bookData.forEach(n => {
      if (n.category_id === null) {
        rt.push({
          key: n.id,
          icon: <BookOutlined />,
          text_title: n.title,
          title: this.title(n)
        })
      }
    })

    return rt
  }

  shouldComponentUpdate (nextProps, nextState) {
    const c = nextProps.tree === this.props.tree
    const d = nextProps.data === this.props.data
    if (c && d) return false
    return true
  }

  render () {
    const { treeDom, onCheck } = this
    return (
      <div>
        <DirectoryTree
          multiple
          checkable
          draggable
          switcherIcon={<DownOutlined />}
          showIcon={true}
          treeData={treeDom}
          onCheck={onCheck}
        />
      </div>
    );
  }
};

export default TreeComponent
